'use strict'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.axios.defaults.timeout = 60 * 1000
Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.put['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.patch['Content-Type'] = 'application/json'
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL || document.getElementById('app').getAttribute('base-uri') || ''
